import { render, staticRenderFns } from "./DoingExercises.vue?vue&type=template&id=fdb55040&scoped=true"
import script from "./DoingExercises.vue?vue&type=script&lang=js"
export * from "./DoingExercises.vue?vue&type=script&lang=js"
import style0 from "./DoingExercises.vue?vue&type=style&index=0&id=fdb55040&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdb55040",
  null
  
)

export default component.exports